import { getGroup } from "@api/groups";
import type { RouteLoadFunc } from "@solidjs/router";

export const loadGroup: RouteLoadFunc = ({ params }) => {
	void getGroup(params.uuid);
};
